<template>
	<v-container id="dashboard-view" fluid tag="section">
		<v-row>
			<v-col cols="12" md="12" v-if="dashboardSettings.stats && checkPermission('Dashboard_Stats')">
				<material-card icon="mdi-scale-balance" icon-small title="آمار سیستم" color="secondary">
					<v-card-text>
						<div>
							<v-row>
								<v-col cols="12" md="3">
									<div class="text-center">
										<h6 class="text-h6 grey--text">
											تعداد مشتری:
										</h6>
										<div class="text-h4 v-card__subtitle--material-stats">
											{{ monthStat.memberCount }}
										</div>
										<h5 class="text-h6 grey--text">
											تعداد پرونده وام:
										</h5>
										<div class="text-h4 v-card__subtitle--material-stats" style="cursor: pointer" @click="() => { filterOnlyCheckout = false; dialogMemberLoans = true }">
											{{ monthStat.allLoansCount }}
										</div>
										<h5 class="text-h6 grey--text">
											تعداد وام تسویه:
										</h5>
										<div class="text-h4 v-card__subtitle--material-stats" style="cursor: pointer" @click="() => { filterOnlyCheckout = true; dialogMemberLoans = true }">
											{{ monthStat.allCheckoutedCount }}
										</div>
									</div>
								</v-col>
								<v-col cols="12" md="6">
									<div class="text-center">
										<h5 class="text-h6 grey--text">
											مجموع خالص وام ها:
										</h5>
										<div class="text-h4 v-card__subtitle--material-stats mb-2">
											{{ monthStat.totalLoans.toString().toPriceFormat() }} تومان
										</div>
										<h5 class="text-h6 grey--text">
											مجموع وام ها با احتساب بهره:
										</h5>
										<div class="text-h4 v-card__subtitle--material-stats mb-2">
											{{ monthStat.totalProfitLoans.toString().toPriceFormat() }} تومان
										</div>
										<h5 class="text-h6 grey--text">
											مجموع وام ها با احتساب بهره و دیرکرد:
										</h5>
										<div class="text-h4 v-card__subtitle--material-stats">
											{{ monthStat.totalProfitDelayLoans.toString().toPriceFormat() }} تومان
										</div>
									</div>
								</v-col>
								<v-col cols="12" md="3">
									<div class="text-center">
										<h5 class="text-h6 grey--text">
											مجموع وصول شده:
										</h5>
										<div class="text-h4 v-card__subtitle--material-stats mb-2">
											{{ monthStat.totalPaid.toString().toPriceFormat() }} تومان
										</div>
										<h5 class="text-h6 grey--text">
											مجموع وصول نشده:
										</h5>
										<div class="text-h4 v-card__subtitle--material-stats mb-2">
											{{ monthStat.totalUnpaid.toString().toPriceFormat() }} تومان
										</div>
										<h5 class="text-h6 grey--text">
											مجموع وصول نشده سررسید نشده:
										</h5>
										<div class="text-h4 v-card__subtitle--material-stats">
											{{ monthStat.totalNonDueDated.toString().toPriceFormat() }} تومان
										</div>
									</div>
								</v-col>
							</v-row>
						</div>
					</v-card-text>
				</material-card>
			</v-col>
			<v-col cols="12" sm="5" md="3" v-if="dashboardSettings.overDueInstallments">
				<material-stat-card v-bind="overdueStat">
					<template #subtitle>
						<div style="cursor:pointer" @click="viewOverDueInstallments">
							اقساط سررسید شده و معوق ها
						</div>
					</template>

					<template #actions>
						<v-icon class="mr-2" small> {{ overdueStat.actionIcon }} </v-icon>
						<small class="text-truncate" v-html="overdueStat.actionText" />
					</template>
					<div class="text-center" style="cursor:pointer" @click="viewOverDueInstallments">
						<!-- <div class="text-h4 v-card--material__title pl-3">
							اقساط سررسید شده و معوق ها
						</div> -->
						<div class="text-h4 v-card__subtitle--material-stats">
							{{ overdueStat.value.toString().toPriceFormat() }} تومان
						</div>
						<div>{{ overdueStat.count.toString() }} مورد</div>
					</div>
				</material-stat-card>
			</v-col>
			<v-col cols="12" sm="5" md="3" v-if="dashboardSettings.pendingPaymentRequests">
				<material-stat-card v-bind="pendingPaymentRequestStat">

					<template #subtitle>
						<div style="cursor:pointer" @click="viewPendingPaymentRequests">
							اعلام واریزی های جدید
						</div>
					</template>

					<template #actions>
						<v-icon class="mr-2" small> {{ pendingPaymentRequestStat.actionIcon }} </v-icon>
						<small class="text-truncate" v-html="pendingPaymentRequestStat.actionText" />
					</template>
					<div class="text-center" style="cursor:pointer" @click="viewPendingPaymentRequests">
						<div class="text-h4 v-card__subtitle--material-stats">
							{{ pendingPaymentRequestStat.items.length }} مورد
						</div>
						<div style="height:25px"></div>
					</div>
				</material-stat-card>
			</v-col>
			<v-col cols="12" sm="5" md="3" v-if="dashboardSettings.loanRequests">
				<material-stat-card v-bind="loanRequestsStat">

					<template #subtitle>
						<div style="cursor:pointer" @click="routeToLoanRequests">
							درخواست وام ها
						</div>
					</template>

					<template #actions>
						<v-icon class="mr-2" small> {{ loanRequestsStat.actionIcon }} </v-icon>
						<small class="text-truncate" v-html="loanRequestsStat.actionText" />
					</template>
					<div class="text-center" style="cursor:pointer">
						<div class="text-h4 v-card__subtitle--material-stats">
							<div class="text-h5" @click="routeToLoanRequests(loanRequestsStat.newTitle)">
								<small class="grey--text ml-1">{{ loanRequestsStat.newTitle }}:</small>
								<span>{{ loanRequestsStat.new }}</span>
							</div>
							<div class="text-h5" @click="routeToLoanRequests(loanRequestsStat.newReviewTitle)">
								<small class="grey--text ml-1">{{ loanRequestsStat.newReviewTitle }}:</small>
								<span>{{ loanRequestsStat.newReview }}</span>
							</div>
							<div class="text-h5">
								<small class="grey--text ml-1">درخواست های جدید امروز:</small>
								<span>{{ loanRequestsStat.today }} </span>
							</div>
						</div>
					</div>
				</material-stat-card>
			</v-col>
			<v-col cols="12" sm="5" md="3" v-if="dashboardSettings.smsCredit">
				<material-stat-card v-bind="smsCreditStat">

					<template #subtitle>
						<div>
							وضعیت پیامک و ایمیل
						</div>
					</template>

					<template #actions>
						<v-icon class="mr-2" small> {{ smsCreditStat.actionIcon }} </v-icon>
						<small class="text-truncate" v-html="smsCreditStat.actionText" />
					</template>
					<div class="text-center">
						<div class="text-h4 v-card__subtitle--material-stats">
							<div class="text-h5">
								<small class="grey--text">ارسال موفق پیامک امروز:</small>
								<span>{{ smsCreditStat.today }} مورد</span>
							</div>
							<div class="text-h5">
								<small class="grey--text">ارسال موفق ایمیل امروز:</small>
								<span>{{ smsCreditStat.today_email }} مورد</span>
							</div>
							<div class="text-h5"><small class="grey--text">اعتبار پیامک:</small> <span>{{
								smsCreditStat.credit }}
								</span><span v-if="this.settings.defaultSmsPanelText === 'MelliPayamak'">
									صفحه </span> <span v-else> تومان </span></div>
							<div v-if="this.settings.defaultSmsPanelText !== 'JetAqsaat'">
								<span class="text-h6 blue--text" style="cursor:pointer" @click="smsCreditCharge">شارژ
									پنل</span>
							</div>
						</div>
						<div v-if="this.settings.defaultSmsPanelText === 'JetAqsaat'" style="height:13px"></div>
					</div>
				</material-stat-card>
			</v-col>
			<v-col cols="12" sm="5" md="3" v-if="dashboardSettings.agentOverdue">
				<material-stat-card v-bind="agentOverdueStat">

					<template #subtitle>
						<div style="cursor:pointer" @click="viewAgentOverdue">
							سررسید شده های سهم نماینده ها
						</div>
					</template>

					<template #actions>
						<v-icon class="mr-2" small> {{ agentOverdueStat.actionIcon }} </v-icon>
						<small class="text-truncate" v-html="agentOverdueStat.actionText" />
					</template>
					<div class="text-center" style="cursor:pointer" @click="viewAgentOverdue">
						<div class="text-h4 v-card__subtitle--material-stats">
							{{ agentOverdueStat.value.toString().toPriceFormat() }} تومان
						</div>
						<div>{{ agentOverdueStat.count.toString() }} مورد</div>
					</div>
				</material-stat-card>
			</v-col>
			<v-col cols="12" sm="5" md="3" v-if="dashboardSettings.contactOverdue">
				<material-stat-card v-bind="contactOverdueStat">

					<template #subtitle>
						<div style="cursor:pointer" @click="viewContactOverdue">
							سررسید شده های طرف حساب
						</div>
					</template>

					<template #actions>
						<v-icon class="mr-2" small> {{ contactOverdueStat.actionIcon }} </v-icon>
						<small class="text-truncate" v-html="contactOverdueStat.actionText" />
					</template>
					<div class="text-center" style="cursor:pointer" @click="viewContactOverdue">
						<div class="text-h4 v-card__subtitle--material-stats">
							{{ contactOverdueStat.value.toString().toPriceFormat() }} تومان
						</div>
						<div>{{ contactOverdueStat.count.toString() }} مورد</div>
					</div>
				</material-stat-card>
			</v-col>
			<v-col cols="12" sm="5" md="3" v-if="dashboardSettings.sponsoreDueDate">
				<material-stat-card v-bind="sponsoreDueDateStat">

					<template #subtitle>
						<div style="cursor:pointer" @click="viewSponsoreDueDate">
							سررسید شده های اسپانسر
						</div>
					</template>

					<template #actions>
						<div class="d-flex justify-end" style="width: 100%">
							<v-btn fab x-small elevation="0" :loading="sponsoreDueDateLoading" @click="loadSponsoreDueDate"><v-icon small>mdi-refresh</v-icon></v-btn>
							<v-btn fab x-small elevation="0" @click="showStatusSelector('sponsoreDueDate')"><v-icon small>mdi-cog</v-icon></v-btn>
						</div>
					</template>
					<div class="text-center" style="cursor:pointer" @click="viewSponsoreDueDate">
						<div class="text-h4 v-card__subtitle--material-stats">
							{{ sponsoreDueDateStat.value.toString().toPriceFormat() }} تومان
						</div>
						<div>{{ sponsoreDueDateStat.count.toString() }} مورد</div>
					</div>
				</material-stat-card>
			</v-col>

			<v-col cols="12" sm="5" md="3" v-if="dashboardSettings.depositChargeDueDate">
				<material-stat-card v-bind="depositChargeDueDateStat">

					<template #subtitle>
						<div style="cursor:pointer" @click="viewDepositChargeDueDate">
							سررسید واریز به حساب مشتری
						</div>
					</template>

					<template #actions>
						<div class="d-flex justify-end" style="width: 100%">
							<v-btn fab x-small elevation="0" :loading="depositChargeDueDateLoading" @click="loadDepositChargeDueDate"><v-icon small>mdi-refresh</v-icon></v-btn>
							<v-btn fab x-small elevation="0" @click="showStatusSelector('depositChargeDueDate')"><v-icon small>mdi-cog</v-icon></v-btn>
						</div>
					</template>
					<div class="text-center" style="cursor:pointer" @click="viewDepositChargeDueDate">
						<div class="text-h4 v-card__subtitle--material-stats">
							{{ depositChargeDueDateStat.value.toString().toPriceFormat() }} تومان
						</div>
						<div>{{ depositChargeDueDateStat.count.toString() }} مورد</div>
					</div>
				</material-stat-card>
			</v-col>

			<v-col cols="12" sm="5" md="3" v-if="dashboardSettings.ticket && checkActivePart('ticket')">
				<material-stat-card v-bind="ticketStat">

					<template #subtitle>
						<div style="cursor:pointer" @click="routeToTickets(0)">
							تیکت در انتظار بررسی
						</div>
					</template>

					<template #actions>
						<div class="d-flex justify-end" style="width: 100%">
							<v-btn fab x-small elevation="0" :loading="pendingTicketsCountLoading" @click="loadPendingTicketsCount"><v-icon small>mdi-refresh</v-icon></v-btn>
						</div>
					</template>
					<div class="text-center" style="cursor:pointer" @click="routeToTickets(0)">
						<div class="text-h4 v-card__subtitle--material-stats">
							{{ ticketStat.count.toString() }}
						</div>
					</div>
				</material-stat-card>
			</v-col>

			<v-col cols="12" sm="5" md="3" v-if="dashboardSettings.customerOrders && checkActivePart('customerOrders')">
				<material-stat-card v-bind="customerOrderStat">

					<template #subtitle>
						<div style="cursor:pointer" @click="routeToCustomerOrders(0)">
							سفارش خرید های در انتظار بررسی
						</div>
					</template>

					<template #actions>
						<div class="d-flex justify-space-between" style="width: 100%">
							<small class="text-truncate" v-html="loanRequestsStat.actionText" />
							<v-btn fab x-small elevation="0" :loading="pendingCustomerOrdersCountLoading" @click="loadPendingCustomerOrdersCount"><v-icon small>mdi-refresh</v-icon></v-btn>
						</div>
					</template>
					<div class="text-center" style="cursor:pointer" @click="routeToCustomerOrders(0)">
						<div class="text-h4 v-card__subtitle--material-stats">
							{{ customerOrderStat.count.toString() }}
						</div>
					</div>
				</material-stat-card>
			</v-col>

			<v-col cols="12" sm="5" md="3" v-if="dashboardSettings.agentFactorGateway && checkActivePart('agentFactorGateway')">
				<material-stat-card v-bind="agentFactorGatewayStat">

					<template #subtitle>
						<div style="cursor:pointer" @click="routeToAgentFactors(0)">
							صورتحساب های الکترونیکی
						</div>
					</template>

					<template #actions>
						<div class="d-flex justify-space-between" style="width: 100%">
							<small class="text-truncate" v-html="loanRequestsStat.actionText" />
							<v-btn fab x-small elevation="0" :loading="agentFactorGatewayCountLoading" @click="loadAgentFactorGatewayCount"><v-icon small>mdi-refresh</v-icon></v-btn>
						</div>
					</template>
					<div class="text-center" style="cursor:pointer" @click="routeToAgentFactors()">
						<div class="text-h4 v-card__subtitle--material-stats  px-2">
							<div>
								<small class="grey--text ml-1">تعداد کل:</small><small>{{ agentFactorGatewayStat.totalCount.toString() }}</small>
							</div>
							<div>
								<small class="grey--text ml-1">پرداختی مشتری:</small><small>{{ agentFactorGatewayStat.payedByCustomer.toString().toPriceFormat() }}</small>
							</div>
							<div>
								<small class="grey--text ml-1">مجموع کارمزدها:</small><small>{{ agentFactorGatewayStat.commission.toString().toPriceFormat() }}</small>
							</div>
							<div :class="agentFactorGatewayStat.notCheckoutCount > 0 ? 'red--text' : 'grey--text'">
								<small class="ml-1">تعداد تسویه نشده:</small><small>{{ agentFactorGatewayStat.notCheckoutCount.toString() }}</small>
							</div>
							<div :class="agentFactorGatewayStat.notCheckoutCount > 0 ? 'red--text' : 'grey--text'">
								<small class="ml-1">مجموع تسویه نشده:</small><small>{{ agentFactorGatewayStat.notCheckoutAmount.toString().toPriceFormat() }}</small>
							</div>
						</div>
					</div>
				</material-stat-card>
			</v-col>

			<v-col cols="12" sm="5" md="3" v-if="dashboardSettings.memberAuthorization && checkActivePart('memberAuthorization')">
				<material-stat-card v-bind="memberAuthorizationStat">

					<template #subtitle>
						<div>
							احراز هویت ها
						</div>
					</template>

					<template #actions>
						<div class="d-flex justify-space-between" style="width: 100%">
							<small class="text-truncate" v-html="memberAuthorizationStat.actionText" />
							<v-btn fab x-small elevation="0" :loading="memberAuthorizationCountLoading" @click="loadMemberAuthorizationCount"><v-icon small>mdi-refresh</v-icon></v-btn>
						</div>
					</template>
					<div class="text-center" style="cursor:pointer">
						<div class="text-h4 v-card__subtitle--material-stats  px-2">
							<div>
								<small class="grey--text ml-1 pointer" @click="routeToMemberAuthorization('در انتطار بررسی کارشناس')">در انتظار بررسی کارشناس:</small><small>{{ memberAuthorizationStat.adminPending.toString() }}</small>
							</div>
						</div>
					</div>
				</material-stat-card>
			</v-col>

		</v-row>

		<v-row>
			<v-col cols="12" md="12" lg="12" v-if="dashboardSettings.onlineTransactions">
				<material-card icon="mdi-credit-card" class="online-gateway-payments-card" icon-small title="واریز قسط های آنلاین" color="secondary" :loading="onlineTransactionLoading">

					<template v-slot:subtitle style="display:inline-block">
						<small class="grey--text">
							(مجموع واریزهای امروز: {{ String(sumTodayOnlinePayment).toPriceFormat() }})
						</small>
					</template>
					<template v-slot:topActions>
						<v-btn text small color="secondary" @click="viewOnlineGatewayPayments">رکوردهای درگاه پرداخت</v-btn>
						<v-btn icon @click="getTransactionsByPaymentMethod(4)">
							<v-icon>mdi-refresh</v-icon>
						</v-btn>
						<v-menu class="">
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon v-bind="attrs" v-on="on" class="">
									<v-icon>mdi-dots-vertical</v-icon>
								</v-btn>
							</template>
							<v-list>
								<v-list-item link>
									<v-list-item-title @click="addTransaction(4, true)">برداشت جدید</v-list-item-title>
								</v-list-item>
								<v-list-item link>
									<v-list-item-title @click="exportTransactionExcel(4)">دریافت
										اکسل</v-list-item-title>
								</v-list-item>
							</v-list>
						</v-menu>
					</template>
					<v-card-text>
						<v-data-table :headers="cashTransactionHeaders" dense :items="onlineTransactionItems" :items-per-page="15" class="elevation-1">

							<template v-slot:item="row">
								<tr>
									<td class="text-center">
										{{ `${row.item.saveDate_Persian.date}` }}
									</td>
									<td class="text-center">
										{{ `${row.item.debit.toString().toPriceFormat()}` }}
									</td>
									<td class="text-center">
										{{ `${row.item.credit.toString().toPriceFormat()}` }}
									</td>
									<td class="text-center">
										{{ `${row.item.balance.toString().toPriceFormat()}` }}
									</td>
									<td class="text-right" style="white-space:pre" v-html="row.item.description" @click="showManageLoan(row.item.memberId)">

									</td>
									<td class="text-center">
										<v-btn class="mx-1" v-if="row.item.transactionId" fab dark x-small color="pink" @click="removeTransaction(row.item)">
											<v-icon dark>
												mdi-trash-can-outline
											</v-icon>
										</v-btn>
									</td>
								</tr>
							</template>
						</v-data-table>
					</v-card-text>
				</material-card>
			</v-col>
			<v-col cols="12" md="12" lg="12" v-if="dashboardSettings.bankTransactions">
				<material-card icon="mdi-credit-card" icon-small title="تراکنش های بانک" color="info" :loading="bankTransactionLoading">

					<template v-slot:topActions>
						<v-btn text small color="secondary" @click="viewOnlineMoneyTransfers">رکوردهای انتقال وجه
							آنلاین</v-btn>
						<v-btn icon @click="getTransactionsByPaymentMethod(2)">
							<v-icon>mdi-refresh</v-icon>
						</v-btn>
						<v-menu class="">
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon v-bind="attrs" v-on="on" class="">
									<v-icon>mdi-dots-vertical</v-icon>
								</v-btn>
							</template>
							<v-list>
								<v-list-item link>
									<v-list-item-title @click="addTransaction(2, false)">واریز جدید</v-list-item-title>
								</v-list-item>
								<v-list-item link>
									<v-list-item-title @click="addTransaction(2, true)">برداشت جدید</v-list-item-title>
								</v-list-item>
								<v-list-item link>
									<v-list-item-title @click="exportTransactionExcel(1)">دریافت
										اکسل</v-list-item-title>
								</v-list-item>
								<v-list-item link>
									<v-list-item-title @click="getTransactionsByPaymentMethod(2, true)">تراکنش های
										نامعلوم</v-list-item-title>
								</v-list-item>
								<v-list-item link>
									<v-list-item-title @click="showTransactionsByDateDialog(2)">بر اساس بازه
										تاریخ</v-list-item-title>
								</v-list-item>
							</v-list>
						</v-menu>
					</template>
					<v-card-text>
						<v-data-table :headers="bankTransactionHeaders" dense :items="bankTransactionItems" :items-per-page="15" class="elevation-1">

							<template v-slot:item="row">
								<tr>
									<td class="text-center">
										{{
											`${row.item.saveDate_Persian.year}/${row.item.saveDate_Persian.month}/${row.item.saveDate_Persian.day}`
										}}
									</td>
									<td class="text-center">
										{{ `${row.item.debit.toString().toPriceFormat()}` }}
									</td>
									<td class="text-center">
										{{ `${row.item.credit.toString().toPriceFormat()}` }}
									</td>
									<td class="text-center">
										{{ `${row.item.balance.toString().toPriceFormat()}` }}
									</td>
									<td class="text-right" style="white-space:pre" v-html="row.item.description" @click="showManageLoan(row.item.memberId)">

									</td>
									<td class="text-center">
										<v-icon color="success" v-if="!!row.item.successfullOnlineMoneyTransferId" title="دارای تراکنش آنلاین" small>mdi-credit-card-check-outline</v-icon>
									</td>
									<td class="text-right">
										<v-btn class="mx-1" v-if="row.item.transactionId" fab dark x-small color="secondary" @click="editTransaction(row.item)">
											<v-icon dark>
												mdi-square-edit-outline
											</v-icon>
										</v-btn>
										<v-btn class="mx-1" v-if="row.item.transactionId" fab dark x-small color="pink" @click="removeTransaction(row.item)">
											<v-icon dark>
												mdi-trash-can-outline
											</v-icon>
										</v-btn>
										<v-btn class="mx-1" v-if="row.item.isUnknown" title="ثبت واریزی قسط" fab dark x-small color="secondary" @click="showUnknownTransactionToPayment(row.item)">
											<v-icon dark>
												mdi-help
											</v-icon>
										</v-btn>
									</td>
								</tr>
							</template>
						</v-data-table>
					</v-card-text>
				</material-card>
			</v-col>
			<v-col cols="12" md="12" lg="12" v-if="dashboardSettings.cashTransactions">
				<material-card icon="mdi-cash-multiple" icon-small title="تراکنش های صندوق" color="green" :loading="cashTransactionLoading">

					<template v-slot:topActions>
						<v-btn icon @click="getTransactionsByPaymentMethod(1)">
							<v-icon>mdi-refresh</v-icon>
						</v-btn>
						<v-menu class="">
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon v-bind="attrs" v-on="on" class="">
									<v-icon>mdi-dots-vertical</v-icon>
								</v-btn>
							</template>
							<v-list>
								<v-list-item link>
									<v-list-item-title @click="addTransaction(1, false)">واریز جدید</v-list-item-title>
								</v-list-item>
								<v-list-item link>
									<v-list-item-title @click="addTransaction(1, true)">برداشت جدید</v-list-item-title>
								</v-list-item>
								<v-list-item link>
									<v-list-item-title @click="exportTransactionExcel(2)">دریافت
										اکسل</v-list-item-title>
								</v-list-item>
								<v-list-item link>
									<v-list-item-title @click="getTransactionsByPaymentMethod(1, true)">تراکنش های
										نامعلوم</v-list-item-title>
								</v-list-item>
								<v-list-item link>
									<v-list-item-title @click="showTransactionsByDateDialog(1)">بر اساس بازه
										تاریخ</v-list-item-title>
								</v-list-item>
							</v-list>
						</v-menu>
					</template>
					<v-card-text>
						<v-data-table :headers="cashTransactionHeaders" :items="cashTransactionItems" dense :items-per-page="15" class="elevation-1">

							<template v-slot:item="row">
								<tr>
									<td class="text-center">
										{{
											`${row.item.saveDate_Persian.year}/${row.item.saveDate_Persian.month}/${row.item.saveDate_Persian.day}`
										}}
									</td>
									<td class="text-center">
										{{ `${row.item.debit.toString().toPriceFormat()}` }}
									</td>
									<td class="text-center">
										{{ `${row.item.credit.toString().toPriceFormat()}` }}
									</td>
									<td class="text-center">
										{{ `${row.item.balance.toString().toPriceFormat()}` }}
									</td>
									<td class="text-right" style="white-space:pre" v-html="row.item.description" @click="showManageLoan(row.item.memberId)">

									</td>
									<td class="text-center">
										<v-btn class="mx-1" v-if="row.item.transactionId" fab dark x-small color="pink" @click="removeTransaction(row.item)">
											<v-icon dark>
												mdi-trash-can-outline
											</v-icon>
										</v-btn>
									</td>
								</tr>
							</template>
						</v-data-table>
					</v-card-text>
				</material-card>
			</v-col>
			<v-col cols="12" md="12" lg="12" v-if="dashboardSettings.goldTransactions">
				<material-card icon="mdi-dropbox" icon-small title="جعبه شکن" color="primary" :loading="goldTransactionLoading">

					<template v-slot:topActions>
						<v-btn icon @click="getTransactionsByPaymentMethod(3)">
							<v-icon>mdi-refresh</v-icon>
						</v-btn>
						<v-menu class="">
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon v-bind="attrs" v-on="on" class="">
									<v-icon>mdi-dots-vertical</v-icon>
								</v-btn>
							</template>
							<v-list>
								<v-list-item link>
									<v-list-item-title @click="addTransaction(3, false)">واریز</v-list-item-title>
								</v-list-item>
								<v-list-item link>
									<v-list-item-title @click="addTransaction(3, true)">برداشت</v-list-item-title>
								</v-list-item>
								<v-list-item link>
									<v-list-item-title @click="exportTransactionExcel(3)">دریافت
										اکسل</v-list-item-title>
								</v-list-item>
							</v-list>
						</v-menu>
					</template>
					<v-card-text>
						<v-data-table :headers="goldTransactionHeaders" :items="goldTransactionItems" :items-per-page="15" class="elevation-1">

							<template v-slot:item="row">
								<tr>
									<td class="text-center">
										{{
											`${row.item.saveDate_Persian.year}/${row.item.saveDate_Persian.month}/${row.item.saveDate_Persian.day}`
										}}
									</td>
									<td class="text-center">
										<div>{{ `${row.item.debit.toString().toPriceFormat()}` }}</div>
										<div v-if="row.item.debit > 0">{{ `وزن: ${row.item.goldWeight}` }}</div>
									</td>
									<td class="text-center">
										{{ `${row.item.credit.toString().toPriceFormat()}` }}
										<div v-if="row.item.credit > 0">{{ `وزن: ${row.item.goldWeight}` }}</div>
									</td>
									<td class="text-center">
										{{ `${row.item.balance.toString().toPriceFormat()}` }}
									</td>
									<td class="text-center">
										{{ `${row.item.goldWeightBalance.toString().toPriceFormat()}` }}
									</td>
									<td class="text-right" style="white-space:pre" v-html="row.item.description" @click="showManageLoan(row.item.memberId)">

									</td>
									<td class="text-center">
										<v-btn class="mx-1" fab dark v-if="row.item.transactionId" x-small color="pink" @click="removeTransaction(row.item)">
											<v-icon dark small>
												mdi-trash-can-outline
											</v-icon>
										</v-btn>
									</td>
								</tr>
							</template>
						</v-data-table>
					</v-card-text>
				</material-card>
			</v-col>
		</v-row>
		<!-- <v-row>
			<v-col cols="12" lg="6">
				<material-card color="orange" full-header>
					<template #heading>
						<div class="pa-8 white--text">
							<div class="text-h4 font-weight-light">
								لیست آخرین نفرات مراجعه کننده به پنل
							</div>
							<div class="text-caption">
								لیست آخرین مراجعه کنندگانی که به پنل کاربری خود مراجعه کرده اند
							</div>
						</div>
					</template>
					<v-card-text>
						<v-data-table :headers="lastLoginHeaders" :items="lastLoginItems" />
					</v-card-text>
				</material-card>
			</v-col>
		</v-row> -->

		<v-row>
			<v-col v-for="(chart, i) in charts" :key="`chart-${i}`" cols="12" lg="6">
				<material-chart-card :color="chart.color" :data="chart.data" :options="chart.options" :responsive-options="chart.responsiveOptions" :title="chart.title" :type="chart.type">

					<template #subtitle>
						<div class="font-weight-light text--secondary">
							<div v-html="chart.subtitle" />
						</div>
					</template>
				</material-chart-card>
			</v-col>
		</v-row>

		<v-dialog v-model="dialogLastMonthInstallments" scrollable max-width="1100px">
			<v-card>
				<v-card-title>
					<div><span class="headline">لیست اقساط</span></div>
					<v-spacer />
					<v-btn @click="dialogLastMonthInstallments = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<installments-by-month ref="installments" :date="lastMonthPersianDate" />
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn @click="dialogLastMonthInstallments = false">
						بستن
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogOverDueInstallments" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">لیست اقساط سررسید شده و معوق</span></div>
					<v-spacer />
					<v-btn @click="dialogOverDueInstallments = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text style="height: 600px;">
					<v-container fluid>
						<over-due-installments ref="installments" v-if="dialogOverDueInstallments" @changed="loadData" />
					</v-container>
				</v-card-text>

			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogAgentOverDue" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">لیست سررسید شده های سهم نماینده ها</span></div>
					<v-spacer />
					<v-btn @click="dialogAgentOverDue = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text style="height: 600px;">
					<v-container fluid>
						<agent-over-due v-if="dialogAgentOverDue" @changed="loadData" />
					</v-container>
				</v-card-text>

			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogContactOverDue" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">لیست سررسید شده های سهم طرف حساب ها</span></div>
					<v-spacer />
					<v-btn @click="dialogContactOverDue = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text style="height: 600px;">
					<v-container fluid>
						<contact-over-due v-if="dialogContactOverDue" @changed="loadData" />
					</v-container>
				</v-card-text>

			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogSponsoreDueDate" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">لیست سررسید شده های اسپانسر ها</span></div>
					<v-spacer />
					<v-btn @click="dialogSponsoreDueDate = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text style="height: 600px;">
					<v-container fluid>
						<duedated-requests-by-sponsore v-if="dialogSponsoreDueDate" @changed="loadData" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogDepositChargeDueDate" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">لیست سررسید شده های مشتریان</span></div>
					<v-spacer />
					<v-btn @click="dialogDepositChargeDueDate = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text style="height: 600px;">
					<v-container fluid>
						<deposit-charge-over-due v-if="dialogDepositChargeDueDate" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogOnlineGatewayPayments" scrollable max-width="1100px">
			<v-card>
				<v-card-title>
					<div><span class="headline"></span></div>
					<v-spacer />
					<v-btn @click="dialogOnlineGatewayPayments = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text style="height: 600px;">
					<v-container fluid>
						<online-gateway-payments ref="onlineGatewayPayments" v-if="dialogOnlineGatewayPayments" />
					</v-container>
				</v-card-text>

			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogOnlineMoneyTransfers" scrollable max-width="1100px">
			<v-card>
				<v-card-title>
					<div><span class="headline">لیست رکورد های انتقال وجه آنلاین</span></div>
					<v-spacer />
					<v-btn @click="dialogOnlineMoneyTransfers = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text style="height: 600px;">
					<v-container fluid>
						<online-money-transfers ref="onlineMoneyTransfers" v-if="dialogOnlineMoneyTransfers" />
					</v-container>
				</v-card-text>

			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogPendingPaymentRequest" scrollable max-width="1100px">
			<v-card>
				<v-card-title>
					<div><span class="headline">لیست اعلام واریزی های جدید</span></div>
					<v-spacer />
					<v-btn @click="dialogPendingPaymentRequest = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text style="height: 600px;">
					<v-container>
						<user-loan-payment-requests ref="pendingPaymentRequest" v-if="dialogPendingPaymentRequest" :status="'pending'" :data="pendingPaymentRequestStat.items" @changed="loadPendingPaymentRequest" />
					</v-container>
				</v-card-text>

			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogTransaction" scrollable max-width="925px">
			<v-card>
				<v-card-title>
					<div><span class="headline"></span></div>
					<v-spacer />
					<v-btn @click="dialogTransaction = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<modify-transaction v-if="dialogTransaction" :data="selectedTransaction" @callbck="callbck_transaction" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogExportTransaction" scrollable max-width="525px">
			<v-card>
				<v-card-title>
					<div><span class="headline"></span></div>
					<v-spacer />
					<v-btn @click="dialogExportTransaction = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<export-excel-transaction v-if="dialogExportTransaction" :data="[]" :headers="exportExcelHeaders" :paymentMethod="exportExcelPaymentMethod" @callbck="callbck_exportExcelTransaction" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogMemberLoans" scrollable max-width="925px">
			<v-card>
				<v-card-title>
					<div><span class="headline"></span></div>
					<v-spacer />
					<v-btn @click="dialogMemberLoans = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<member-loans v-if="dialogMemberLoans" :hideDateRange="false" :autoSubmit="true" :filterOnlyCheckout="filterOnlyCheckout" :reportTitle="filterOnlyCheckout ? 'وام های تسویه شده' : ''" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogStatusSelector" scrollable max-width="600px">
			<status-selector-for-dashboard v-if="dialogStatusSelector" :type="statusSelectorType" @close="dialogStatusSelector = false" />
		</v-dialog>

		<v-dialog v-model="dialogLoansManager" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">مدیریت وام</span></div>
					<v-spacer />
					<v-btn @click="dialogLoansManager = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<manage-loan ref="manageLoan" v-if="dialogLoansManager" :data="{ member: selectedMember }" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogUnknownTransactionToPayment" scrollable max-width="600px">
			<v-card>
				<v-card-title>
					<div><span class="headline">ثبت قسط از واریزی نامعلوم </span></div>
					<v-spacer />
					<v-btn @click="dialogUnknownTransactionToPayment = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<unknown-transaction-toPayment v-if="dialogUnknownTransactionToPayment" :data="selectedTransaction" @close="dialogUnknownTransactionToPayment = false" @callback="unknownPayemnt_callback" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogTransactionsByDate" scrollable max-width="600px">
			<v-card>
				<v-card-title>
					<div><span class="headline">دریافت لیست تراکنش ها بر اساس بازه زمانی</span></div>
					<v-spacer />
					<v-btn @click="dialogTransactionsByDate = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-row class="my-5">
						<v-col cols="12" md="6">
							<div>
								<div class="mb-2">تاریخ شروع:</div>
								<date-picker v-model="transactionDateRange.start" format="YYYY-MM-DDTHH:mm:ss" auto-submit display-format="jYYYY/jMM/jDD" />
							</div>
						</v-col>
						<v-col cols="12" md="6">
							<div>
								<div class="mb-2">تاریخ پایان:</div>
								<date-picker v-model="transactionDateRange.end" format="YYYY-MM-DDTHH:mm:ss" auto-submit display-format="jYYYY/jMM/jDD" />
							</div>
						</v-col>
						<v-col cols="12" class="text-center">
							<v-btn color="secondary" small @click="getTransactionsByDate()">دریافت اطلاعات</v-btn>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>

		<confirm-dlg ref="confirm" />

	</v-container>
</template>

<script>
	// Utilities
	import { get } from 'vuex-pathify'
	import Vue from 'vue'
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import router from '@/router'
	import { emptyId } from '@/util/emptyId'
	import ManageLoan from '@/views/admin/ManageLoan.vue'
	import { sumBy } from 'lodash'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

	const lineSmooth = Vue.chartist.Interpolation.cardinal({
		tension: 0,
	})

	export default {
		name: 'DashboardView',
		components: {
			'date-picker': VuePersianDatetimePicker,
			'over-due-installments': () => import('./Report/OverDueInstallments.vue'),
			'agent-over-due': () => import('./Report/AgentOverDue.vue'),
			'contact-over-due': () => import('./Report/ContactOverDue.vue'),
			'deposit-charge-over-due': () => import('./Report/DepositChargeOverDue.vue'),
			'installments-by-month': () => import('./InstallmentsByMonth'),
			'modify-transaction': () => import('./ModifyTransaction'),
			'export-excel-transaction': () => import('./ExportExcelTransaction'),
			'user-loan-payment-requests': () => import('./UserLoanPaymentRequests'),
			'online-gateway-payments': () => import('./Report/OnlineGatewayPayments.vue'),
			'online-money-transfers': () => import('./Report/OnlineMoneyTransfers.vue'),
			'duedated-requests-by-sponsore': () => import('./Report/DueDatedRequestsBySponsore.vue'),
			'member-loans': () => import('./Report/MemberLoans.vue'),
			'status-selector-for-dashboard': () => import('@/components/StatusSelectorForDashboard.vue'),
			'unknown-transaction-toPayment': () => import('@/components/forms/UnknownTransactionToPayment.vue'),
			ManageLoan,
		},

		data: () => ({
			selectedTransaction: null,
			charts: {
				loan: {
					type: 'Line',
					color: 'success',
					title: 'آمار وام های جدید',
					subtitle: 'نمودار مجموع وام های اعطا شده در یکسال گذشته ',
					data: {
						labels: [],
						series: [
							[],
						],
					},
					options: {
						lineSmooth,
						low: 0,
						high: 100000000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
						chartPadding: {
							top: 0,
							right: 0,
							bottom: 0,
							left: 0,
						},
						axisY: {
							offset: 90,
							labelInterpolationFnc: function (value) {
								return value.toString().toPriceFormat()
							},
						},
					},
				},
				payment: {
					type: 'Line',
					color: 'info',
					title: 'آمار اقساط',
					subtitle: 'نمودار مجموع اقساط ثبت شده در یکسال گذشته ',
					data: {
						labels: [],
						series: [[]],
					},
					options: {
						lineSmooth,
						low: 0,
						high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
						chartPadding: {
							top: 0,
							right: 0,
							bottom: 0,
							left: 0,
						},
						axisY: {
							offset: 90,
							labelInterpolationFnc: function (value) {
								return value.toString().toPriceFormat()
							},
						},
					},
				},
			},
			lastLoginHeaders: [
				{
					sortable: false,
					text: 'نام',
					value: 'fullName',
				},
				{
					sortable: false,
					text: 'کد پرسنلی',
					value: 'personalCode',
					align: 'right',
				},
				{
					sortable: false,
					text: 'آخرین فعالیت',
					value: 'lastLoginDate',
					align: 'center',
				},
			],
			lastLoginItems: [],
			goldTransactionItems: [],
			onlineTransactionItems: [],
			bankTransactionItems: [],
			cashTransactionItems: [],
			cashTransactionHeaders: [
				{
					sortable: false,
					text: 'تاریخ',
					value: 'saveDate_Persian.date',
					align: 'center',
				},
				{
					sortable: false,
					text: 'واریز',
					value: 'debit',
					align: 'center',
				},
				{
					sortable: false,
					text: 'برداشت',
					value: 'credit',
					align: 'center',
				},
				{
					sortable: false,
					text: 'مانده',
					value: 'balance',
					align: 'center',
				},
				{
					sortable: false,
					text: 'شرح',
					value: 'description',
				},
				{
					sortable: false,
					text: '',
					align: 'center',
				},
			],
			bankTransactionHeaders: [
				{
					sortable: false,
					text: 'تاریخ',
					value: 'saveDate_Persian.date',
					align: 'center',
				},
				{
					sortable: false,
					text: 'واریز',
					value: 'debit',
					align: 'center',
				},
				{
					sortable: false,
					text: 'برداشت',
					value: 'credit',
					align: 'center',
				},
				{
					sortable: false,
					text: 'مانده',
					value: 'balance',
					align: 'center',
				},
				{
					sortable: false,
					text: 'شرح',
					value: 'description',
				},
				{
					text: '',
					align: 'start',
					sortable: true,
					value: 'successfullOnlineMoneyTransferId',
					width: 30
				},
				{
					sortable: false,
					text: '',
					align: 'right',
					width: 160
				},
			],
			goldTransactionHeaders: [
				{
					sortable: false,
					text: 'تاریخ',
					value: 'saveDate_Persian.date',
					align: 'center',
				},
				{
					sortable: false,
					text: 'واریز',
					value: 'debit',
					align: 'center',
				},
				{
					sortable: false,
					text: 'برداشت',
					value: 'credit',
					align: 'center',
				},
				{
					sortable: false,
					text: 'مانده',
					value: 'balance',
					align: 'center',
				},
				{
					sortable: false,
					text: 'مانده وزنی',
					value: 'weightBalance',
					align: 'center',
				},
				{
					sortable: false,
					text: 'شرح',
					value: 'description',
				},
				{
					sortable: false,
					text: '',
					align: 'center',
				},
			],
			monthStat: {
				actionIcon: 'mdi-calendar',
				actionText: 'آمار سیستم',
				iconSmall: true,
				color: '#FD9A13',
				icon: 'mdi-scale-balance',
				title: '',
				value: '',
				totalUnpaid: 0,
				totalPaid: 0,
				allCheckoutedCount: 0,
				allLoansCount: 0,
				totalProfitDelayLoans: 0,
				totalProfitLoans: 0,
				totalLoans: 0,
				memberCount: 0,
				totalNonDueDated: 0
			},
			stats: {
				loans: {
					actionIcon: 'mdi-tag',
					actionText: 'مجموع کل مبلغ وام های اعطا شده',
					color: 'primary',
					icon: 'mdi-account-cash',
					iconSmall: true,
					title: 'مجموع وام ها',
					value: '',
				},
				paids: {
					actionIcon: 'mdi-tag',
					actionText: 'مجموع کل مبلغ اقساط پرداخت شده',
					color: 'success',
					icon: 'mdi-cash-check',
					iconSmall: true,
					title: 'مجموع اقساط پرداختی',
					value: '',
				},
				unpaids: {
					actionIcon: 'mdi-tag',
					actionText: 'مبلغ کل باقیمانده اقساط',
					color: 'info',
					icon: 'mdi-cash-remove',
					iconSmall: true,
					title: 'مجموع باقیمانده ها',
					value: '',
				},
			},
			overdueStat: {
				actionIcon: 'mdi-tag',
				actionText: 'جهت مشاهده بر روی باکس کلیک کنید',
				color: 'secondary',
				icon: 'mdi-flower-tulip',
				iconSmall: true,
				title: '',
				value: '',
				count: '0'
			},
			pendingPaymentRequestStat: {
				actionIcon: 'mdi-tag',
				actionText: 'جهت مشاهده بر روی باکس کلیک کنید',
				color: 'primary',
				icon: 'mdi-flower-tulip',
				iconSmall: true,
				title: '',
				value: '',
				items: [],
				count: '0'
			},
			loanRequestsStat: {
				actionIcon: 'mdi-tag',
				actionText: 'جهت مشاهده بر روی باکس کلیک کنید',
				color: 'info',
				icon: 'mdi-flower-tulip',
				iconSmall: true,
				title: '',
				value: '',
				items: [],
				new: '0',
				newTitle: '',
				today: '0',
				newReview: '0',
				newReviewTitle: ''
			},
			smsCreditStat: {
				actionIcon: 'mdi-tag',
				actionText: 'شارژ از بخش تنظیمات اپلیکیشن قابل انجام است',
				color: 'warning',
				icon: 'mdi-message',
				iconSmall: true,
				title: '',
				value: '',
				items: [],
				credit: '',
				today: '',
				today_email: ''
			},
			agentOverdueStat: {
				actionIcon: 'mdi-tag',
				actionText: 'جهت مشاهده بر روی باکس کلیک کنید',
				color: 'secondary',
				icon: 'mdi-flower-tulip',
				iconSmall: true,
				title: '',
				value: '',
				count: '0'
			},
			contactOverdueStat: {
				actionIcon: 'mdi-tag',
				actionText: 'جهت مشاهده بر روی باکس کلیک کنید',
				color: 'primary',
				icon: 'mdi-flower-tulip',
				iconSmall: true,
				title: '',
				value: '',
				count: '0'
			},
			sponsoreDueDateStat: {
				actionIcon: 'mdi-tag',
				actionText: 'جهت مشاهده بر روی باکس کلیک کنید',
				color: 'info',
				icon: 'mdi-flower-tulip',
				iconSmall: true,
				title: '',
				value: '',
				count: '0'
			},
			depositChargeDueDateStat: {
				actionIcon: 'mdi-tag',
				actionText: 'جهت مشاهده بر روی باکس کلیک کنید',
				color: 'warning',
				icon: 'mdi-flower-tulip',
				iconSmall: true,
				title: '',
				value: '',
				count: '0'
			},
			ticketStat: {
				actionIcon: 'mdi-tag',
				actionText: 'جهت مشاهده بر روی باکس کلیک کنید',
				color: 'warning',
				icon: 'mdi-email-fast',
				iconSmall: true,
				title: '',
				value: '',
				count: '0'
			},
			customerOrderStat: {
				actionIcon: 'mdi-tag',
				actionText: 'جهت مشاهده بر روی باکس کلیک کنید',
				color: 'warning',
				icon: 'mdi-invoice',
				iconSmall: true,
				title: '',
				value: '',
				count: '0'
			},
			agentFactorGatewayStat: {
				actionIcon: 'mdi-tag',
				actionText: 'جهت مشاهده بر روی باکس کلیک کنید',
				color: 'info',
				icon: 'mdi-invoice',
				iconSmall: true,
				title: '',
				totalCount: 0,
				payedByCustomer: 0,
				commission: 0,
				notCheckoutCount: 0,
				notCheckoutAmount: 0,
			},
			memberAuthorizationStat: {
				actionIcon: 'mdi-tag',
				actionText: 'جهت مشاهده بر روی باکس کلیک کنید',
				color: 'info',
				icon: 'mdi-credit-card-lock',
				iconSmall: true,
				title: '',
				adminPending: 0,
			},
			expenseStat: {
				actionIcon: 'mdi-tag',
				actionText: 'مجموع 1 درصد از وام ها بابت هزینه های صندوق',
				color: 'info',
				icon: 'mdi-flower-tulip',
				title: '',
				value: '',
				costShare: 0,
				expense: 0,
				remain: 0,
			},
			stats2: {
				checkoutedThisMonth: {
					actionIcon: 'mdi-tag',
					actionText: '',
					color: 'primary',
					icon: 'mdi-account-cash',
					title: '',
					value: '',
				},
				allCheckouted: {
					actionIcon: 'mdi-tag',
					actionText: '',
					color: 'info',
					icon: 'mdi-account-cash',
					title: '',
					value: '',
				},
			},
			tabs: 0,
			sponsoreDueDateLoading: false,
			depositChargeDueDateLoading: false,
			dialogUnknownTransactionToPayment: false,
			dialogLastMonthInstallments: false,
			dialogLastMonthSavedMonies: false,
			dialogTransaction: false,
			dialogOverDueInstallments: false,
			dialogAgentOverDue: false,
			dialogContactOverDue: false,
			dialogDepositChargeDueDate: false,
			dialogSponsoreDueDate: false,
			dialogSponsoreDueDate: false,
			dialogOnlineGatewayPayments: false,
			dialogOnlineMoneyTransfers: false,
			dialogPendingPaymentRequest: false,
			dialogExportTransaction: false,
			dialogMemberLoans: false,
			dialogLoansManager: false,
			dialogStatusSelector: false,
			dialogTransactionsByDate: false,
			cashTransactionLoading: false,
			bankTransactionLoading: false,
			goldTransactionLoading: false,
			onlineTransactionLoading: false,
			pendingTicketsCountLoading: false,
			pendingCustomerOrdersCountLoading: false,
			agentFactorGatewayCountLoading: false,
			memberAuthorizationCountLoading: false,
			lastMonthPersianDate: '',
			exportExcelHeaders: [],
			exportExcelPaymentMethod: 0,
			filterOnlyCheckout: false,
			statusSelectorType: '',
			selectedMember: null,
			selectedPaymentMethod: null,
			sumTodayOnlinePayment: 0,
			transactionDateRange: { start: new Date(new Date().setMonth(new Date().getMonth() - 1)).toJSON(), end: new Date().toJSON() }
		}),

		computed: {
			sales: get('sales/sales'),
			...get('appSettings', [
				'settings',
			]),
			...get('siteConfig', [
				'isCloud'
			]),
			dashboardSettings() {
				return this.settings?.dashboardSettings || {}
			},
			totalSales() {
				return this.sales.reduce((acc, val) => acc + val.salesInM, 0)
			},
			bankExcelFileName() {
				return 'تراکنش های بانک تا تاریخ ' + new Date().toISOString().split('T')[0] + '.xls'
			},
			goldExcelFileName() {
				return 'تراکنش های جعبه شکن تا تاریخ ' + new Date().toISOString().split('T')[0] + '.xls'
			},
			cashExcelFileName() {
				return 'تراکنش های صندوق تا تاریخ ' + new Date().toISOString().split('T')[0] + '.xls'
			}
		},

		mounted() {
			this.loadData()

			if (this.dashboardSettings.pendingPaymentRequests)
				this.loadPendingPaymentRequest()

			if (this.dashboardSettings.sponsoreDueDate)
				this.loadSponsoreDueDate()

			if (this.dashboardSettings.depositChargeDueDate)
				this.loadDepositChargeDueDate()

			if (this.dashboardSettings.ticket && this.checkActivePart('ticket'))
				this.loadPendingTicketsCount()

			if (this.dashboardSettings.customerOrders && this.checkActivePart('customerOrders'))
				this.loadPendingCustomerOrdersCount()

			if (this.dashboardSettings.agentFactorGateway && this.checkActivePart('agentFactorGateway'))
				this.loadAgentFactorGatewayCount()

			if (this.dashboardSettings.memberAuthorization && this.checkActivePart('memberAuthorization'))
				this.loadMemberAuthorizationCount()

			if (this.dashboardSettings.smsCredit)
				this.loadSmsCredit()
		},
		methods: {
			getLastLoginMembers() {
				api.get('admin/dashboard/getLastLoginMembers', null)
					.then(
						response => {
							this.lastLoginItems = response
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			getTransactionsByPaymentMethod(paymentMethod, onlyUnknown) {
				switch (paymentMethod) {
					case 1:
						this.cashTransactionLoading = true
						break
					case 2:
						this.bankTransactionLoading = true
						break
					case 3:
						this.goldTransactionLoading = true
					case 4:
						this.onlineTransactionLoading = true
					default:
						break
				}
				api.get('admin/dashboard/TurnOver/' + paymentMethod + `?onlyUnknown=${!!onlyUnknown}`, null)
					.then(
						response => {
							switch (paymentMethod) {
								case 1:
									this.cashTransactionItems = response
									break
								case 2:
									this.bankTransactionItems = response
									break
								case 3:
									this.goldTransactionItems = response
								case 4:
									this.onlineTransactionItems = response
									let todayItems = this.onlineTransactionItems.filter(x => {
										return (new Date()).toISOString().split('T')[0] === x.saveDate.split('T')[0]
									})
									this.sumTodayOnlinePayment = sumBy(todayItems, (x) => x.debit)
								default:
									break
							}
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
						this.cashTransactionLoading = false
						this.bankTransactionLoading = false
						this.goldTransactionLoading = false
						this.onlineTransactionLoading = false
					})
			},
			loadPendingPaymentRequest() {
				api.get('admin/UserLoanPaymentRequest/List/0', null)
					.then(response => {
						this.pendingPaymentRequestStat.items = response
					})
					.catch(err => {
						toast.error(err.message)
					})
			},
			loadSponsoreDueDate() {
				this.sponsoreDueDateLoading = true
				api.get('admin/UserLoanRequest/GetDueDatedRequestsBySponsore', null)
					.then(response => {
						this.sponsoreDueDateStat.value = (response || []).reduce(function (a, b) {
							return a + b.sponsoreAmount
						}, 0).toString()
						this.sponsoreDueDateStat.count = (response || []).length
						this.sponsoreDueDateLoading = false
					})
					.catch(err => {
						toast.error(err.message)
						this.sponsoreDueDateLoading = false
					})
			},
			loadDepositChargeDueDate() {
				this.depositChargeDueDateLoading = true
				api.get('admin/UserLoan/GetDepositChargeDueDate', null)
					.then(response => {
						this.depositChargeDueDateStat.value = response.value.toString()
						this.depositChargeDueDateStat.count = response.count
						this.depositChargeDueDateLoading = false
					})
					.catch(err => {
						toast.error(err.message)
						this.depositChargeDueDateLoading = false
					})
			},
			loadPendingTicketsCount() {
				this.pendingTicketsCountLoading = true
				api.get('admin/dashboard/GetPendingTicketsCount', null)
					.then(response => {
						this.ticketStat.count = response
						this.pendingTicketsCountLoading = false
					})
					.catch(err => {
						toast.error(err.message)
						this.pendingTicketsCountLoading = false
					})
			},
			loadAgentFactorGatewayCount() {
				this.agentFactorGatewayCountLoading = true
				api.get('admin/dashboard/GetAgentFactorGatewayCount', null)
					.then(response => {
						this.agentFactorGatewayStat.totalCount = response.totalCount
						this.agentFactorGatewayStat.payedByCustomer = response.payedByCustomer
						this.agentFactorGatewayStat.commission = response.commission
						this.agentFactorGatewayStat.notCheckoutCount = response.notCheckoutCount
						this.agentFactorGatewayStat.notCheckoutAmount = response.notCheckoutAmount
						this.agentFactorGatewayCountLoading = false
					})
					.catch(err => {
						toast.error(err.message)
						this.agentFactorGatewayCountLoading = false
					})
			},
			loadPendingCustomerOrdersCount() {
				this.pendingCustomerOrdersCountLoading = true
				api.get('admin/dashboard/GetPendingCustomerOrdersCount', null)
					.then(response => {
						this.customerOrderStat.count = response
						this.pendingCustomerOrdersCountLoading = false
					})
					.catch(err => {
						toast.error(err.message)
						this.pendingCustomerOrdersCountLoading = false
					})
			},
			loadMemberAuthorizationCount() {
				this.memberAuthorizationCountLoading = true
				api.get('admin/dashboard/GetMemberAuthorizationCount', null)
					.then(response => {
						this.memberAuthorizationStat.adminPending = response.adminPending
						this.memberAuthorizationCountLoading = false
					})
					.catch(err => {
						toast.error(err.message)
						this.memberAuthorizationCountLoading = false
					})
			},
			loadSmsCredit() {
				api.get('admin/dashboard/GetSmsCredit', null)
					.then(response => {
						this.smsCreditStat.today = response.today
						this.smsCreditStat.today_email = response.today_email
						this.smsCreditStat.credit = this.settings.defaultSmsPanelText === 'JetAqsaat' ? String(Math.round(response.credit)).toPriceFormat() : String(Math.round(response.credit))
						switch (this.settings.defaultSmsPanelText) {
							case 'MelliPayamak':
								this.smsCreditStat.actionText = 'پنل پیامک ملی پیامک'
								break
							case 'Unknown':
							default:
								this.smsCreditStat.actionText = 'پنل پیامک تنظیم نشده است'
								break
						}
					})
					.catch(err => {
						toast.error(err.message)
					})
			},
			loadData() {
				api.get('admin/dashboard/get', null)
					.then(response => {
						const loanChartData = { labels: [], series: [] }
						let high1 = 0
						if (response.loanChart) {
							const series = []
							for (let i = 0; i < response.loanChart.length; i++) {
								loanChartData.labels.push(response.loanChart[i].month)
								series.push(response.loanChart[i].amount)
								high1 = Math.max(high1, response.loanChart[i].amount)
							}
							loanChartData.series.push(series)
						}

						const paymentChartData = { labels: [], series: [] }
						let high2 = 0
						if (response.paymentChart) {
							const series = []
							for (let i = 0; i < response.paymentChart.length; i++) {
								paymentChartData.labels.push(response.paymentChart[i].month)
								series.push(response.paymentChart[i].amount)
								high2 = Math.max(high2, response.paymentChart[i].amount)
							}
							paymentChartData.series.push(series)
						}
						this.charts.loan.data = loanChartData
						this.charts.loan.options.high = high1
						this.charts.payment.data = paymentChartData
						this.charts.payment.options.high = high2

						// this.stats.loans.value = response.totalLoans.toString().toPriceFormat() + '<br/> تومان'
						// this.stats.paids.value = response.totalPaid.toString().toPriceFormat() + '<br/> تومان'
						// this.stats.unpaids.value = response.totalUnpaid.toString().toPriceFormat() + '<br/> تومان'

						// this.stats2.checkoutedThisMonth.value = response.checkoutedThisMonthCount
						// this.stats2.allCheckouted.value = response.allCheckoutedCount

						this.overdueStat.value = response.overDueInstallments.sumByDelays.toString()
						this.overdueStat.count = response.overDueInstallments.count.toString()

						this.agentOverdueStat.value = response.agentOverdue.total.toString()
						this.agentOverdueStat.count = response.agentOverdue.count.toString()

						this.contactOverdueStat.value = response.contactOverdue.total.toString()
						this.contactOverdueStat.count = response.contactOverdue.count.toString()

						this.monthStat.memberCount = response.memberCount
						this.monthStat.totalLoans = response.totalLoans
						this.monthStat.totalProfitLoans = response.totalProfitLoans
						this.monthStat.totalProfitDelayLoans = response.totalProfitDelayLoans
						this.monthStat.totalPaid = response.totalPaid
						this.monthStat.totalUnpaid = response.totalUnpaid
						this.monthStat.totalNonDueDated = response.totalNonDueDated
						this.monthStat.allCheckoutedCount = response.allCheckoutedCount
						this.monthStat.allLoansCount = response.allLoansCount
						// this.monthStat.actionText = `آخرین ماه دریافت شده: ${response.lastMonthPersianDate.monthName} ${response.lastMonthPersianDate.year}`
						// this.lastMonthPersianDate = response.lastMonthPersianDate.date

						// this.expenseStat.costShare = response.costShare
						// this.expenseStat.expense = response.expense
						// this.expenseStat.remain = response.costShare - response.expense

						this.loanRequestsStat.new = response.newLoanRequestCount
						this.loanRequestsStat.newTitle = response.newLoanRequestTitle
						this.loanRequestsStat.today = response.todayLoanRequestCount
						this.loanRequestsStat.newReview = response.newReviewLoanRequestCount
						this.loanRequestsStat.newReviewTitle = response.newReviewLoanRequestTitle
					})
					.catch(err => {
						toast.error(err.message)
					})
			},
			viewLastMonthSavedMonies() {
				this.dialogLastMonthSavedMonies = true
				this.$nextTick(() => {
					this.$refs.savedMonies.loadData()
				})
			},
			viewLastMonthInstallments() {
				this.dialogLastMonthInstallments = true
				this.$nextTick(() => {
					this.$refs.installments.loadData()
				})
			},
			viewThisMonthCheckoutedMembers() {

			},
			viewCheckoutedMembers() {

			},
			viewOverDueInstallments() {
				this.dialogOverDueInstallments = true
			},
			viewAgentOverdue() {
				this.dialogAgentOverDue = true
			},
			viewContactOverdue() {
				this.dialogContactOverDue = true
			},
			viewSponsoreDueDate() {
				this.dialogSponsoreDueDate = true
			},
			viewOnlineGatewayPayments() {
				this.dialogOnlineGatewayPayments = true
			},
			viewOnlineMoneyTransfers() {
				this.dialogOnlineMoneyTransfers = true
			},
			viewPendingPaymentRequests() {
				this.dialogPendingPaymentRequest = true
			},
			viewDepositChargeDueDate() {
				this.dialogDepositChargeDueDate = true
			},
			routeToLoanRequests(status) {
				router.replace(`/admin/UserLoanRequests${status ? '/' + status : ''}`).catch(() => { })
			},
			routeToTickets(status) {
				router.replace(`/admin/tickets${!isNaN(status) ? '/' + status : ''}`).catch(() => { })
			},
			routeToCustomerOrders(status) {
				router.replace(`/admin/customerOrders`).catch(() => { })
			},
			routeToAgentFactors(status) {
				router.replace(`/admin/agentFactors`).catch(() => { })
			},
			routeToMemberAuthorization(status) {
				router.replace(`/admin/memberAuthorizations${status ? '/' + status : ''}`).catch(() => { })
			},
			smsCreditCharge() {
				if (this.settings.defaultSmsPanelText === 'MelliPayamak')
					window.open('https://www.melipayamak.com/', '_blank').focus()
				if (this.settings.defaultSmsPanelText === 'KaveNegar')
					window.open('https://console.kavenegar.com/membership/login', '_blank').focus()
			},
			addTransaction(paymentMethod, isWithdraw) {
				this.selectedTransaction = { id: emptyId, paymentMethod: paymentMethod, isWithdraw: isWithdraw }
				this.dialogTransaction = true
			},
			callbck_transaction(result) {
				this.dialogTransaction = false
				if (result)
					this.getTransactionsByPaymentMethod(this.selectedTransaction.paymentMethod)
			},
			callbck_exportExcelTransaction(result) {
				this.dialogExportTransaction = false
			},
			exportTransactionExcel(type) {
				this.exportExcelPaymentMethod = type
				switch (type) {
					case 1:
						this.exportExcelHeaders = this.cashTransactionHeaders
						break
					case 2:
						this.exportExcelHeaders = this.cashTransactionHeaders
						break
					case 3:
						this.exportExcelHeaders = this.goldTransactionHeaders
					case 4:
						this.exportExcelHeaders = this.cashTransactionHeaders
						break
					default:
						break
				}
				this.dialogExportTransaction = true
			},
			async removeTransaction(item) {
				if (!item) { return }

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					api.post('admin/transaction/delete/' + item.transactionId)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.getTransactionsByPaymentMethod(item.paymentMethod)
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			editTransaction(item) {
				this.selectedTransaction = { ...item }
				this.selectedTransaction.id = item.transactionId
				this.dialogTransaction = true
			},
			showStatusSelector(type) {
				this.statusSelectorType = type
				this.dialogStatusSelector = true
			},
			showManageLoan(memberId) {
				api.get('admin/member/get/' + memberId + "/false", null)
					.then(response => {
						this.selectedMember = response
						this.dialogLoansManager = true
					})
					.catch(err => {
						toast.error(err.message)
					})
			},
			showUnknownTransactionToPayment(item) {
				this.selectedTransaction = { ...item }
				this.selectedTransaction.id = item.transactionId
				this.dialogUnknownTransactionToPayment = true
			},
			showTransactionsByDateDialog(method) {
				this.selectedPaymentMethod = method
				this.dialogTransactionsByDate = true
			},
			getTransactionsByDate() {
				this.dialogTransactionsByDate = false
				switch (this.selectedPaymentMethod) {
					case 1:
						this.cashTransactionLoading = true
						break
					case 2:
						this.bankTransactionLoading = true
						break
					case 3:
						this.goldTransactionLoading = true
					case 4:
						this.onlineTransactionLoading = true
					default:
						break
				}
				api.get('admin/dashboard/TurnOver/' + this.selectedPaymentMethod + `?startDate=${this.transactionDateRange.start}&endDate=${this.transactionDateRange.end}`, null)
					.then(
						response => {
							switch (this.selectedPaymentMethod) {
								case 1:
									this.cashTransactionItems = response
									break
								case 2:
									this.bankTransactionItems = response
									break
								case 3:
									this.goldTransactionItems = response
								case 4:
									this.onlineTransactionItems = response
									let todayItems = this.onlineTransactionItems.filter(x => {
										return (new Date()).toISOString().split('T')[0] === x.saveDate.split('T')[0]
									})
									this.sumTodayOnlinePayment = sumBy(todayItems, (x) => x.debit)
								default:
									break
							}
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
						this.cashTransactionLoading = false
						this.bankTransactionLoading = false
						this.goldTransactionLoading = false
						this.onlineTransactionLoading = false
					})
			},
			async unknownPayemnt_callback() {
				if (await this.$refs.confirm.open(
					'توجه',
					'آیا مایل به حذف تراکنش نامعلوم هستید؟',
				)) {
					api.post('admin/transaction/delete/' + this.selectedTransaction.transactionId)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.getTransactionsByPaymentMethod(this.selectedTransaction.paymentMethod, true)
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			}
		},
	}
</script>

<style>

	svg.ct-chart-bar,
	svg.ct-chart-line {
		overflow: visible;
	}

	.ct-label.ct-label.ct-horizontal.ct-end {
		position: relative;
		justify-content: flex-end;
		text-align: right;
		transform-origin: 100% 0;
		transform: translate(-100%) rotate(-45deg);
		white-space: nowrap;
	}

	.ct-label.ct-vertical.ct-start {
		white-space: pre;
		transform: translateX(-5px);
	}

	.online-gateway-payments-card .text-subtitle-1 {
		display: inline-block;
	}
</style>
